import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Column } from "../components/Column";
import { HomeScreen } from "../../features/home/presentation/pages/HomeScreen";
import "../constants/fonts.css";

export const AppRouter = () => {
	return (
		<Routes>
			<Route element={<Layout />}>
				<Route
					path="/"
					element={<HomeScreen />}
				/>
			</Route>
			<Route
				path="/*"
				element={<Navigate to="/" />}
			/>
		</Routes>
	);
};

const Layout: React.FC = () => {

	return (
		<Column className="bg-[#EFF8FF] overflow-y-auto relative max-h-svh overflow-x-hidden md:flex md:flex-col">
			<main className="w-full min-h-svh overflow-x-hidden md:w-[30rem] md:self-center">
				<Outlet />
			</main>
		</Column>
	);
};
